import CrmServiceModel from "@/models/CrmServiceModel";
import CustomerContactModel from "./CustomerContactModel";
export default class UserModel extends CrmServiceModel {

  modelName() {
    return 'users';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.create = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/public/' + this.modelName();
    routes.exists = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/public/' + this.modelName() + '/exists';
    return routes;
  }

  defaults() {
    return {
      id: null,
      name: null,
      email: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      staff: null,
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      email: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getCustomerContact() {
    return this.getRelatedModel(CustomerContactModel, 'customer_contact');
  }

}
